<style scoped lang="scss">
    .status {
        background: #E6F1FC;
        height: 40px;
    }
</style>
<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pb15">
            <diagnose-base-form></diagnose-base-form>
            <diagnose-diagnose-form></diagnose-diagnose-form>
            <diagnose-consultation-form></diagnose-consultation-form>
            <div class="flex jcc">
                <el-button type="danger" size="mini">取消申请</el-button>
                <el-button type="primary" size="mini" style="margin-left: 30px">提交申请</el-button>
            </div>
        </div>
    </div>
</template>

<script>

  import Breadcrumb from "../../components/common/Breadcrumb";
  import {diagnoseMixin} from "../../lib/mixins/diagnose";
  import DiagnoseBaseForm from "../../components/dignose/base-form";
  import DiagnoseDiagnoseForm from "../../components/dignose/diagnose-form";
  import DiagnoseConsultationForm from "../../components/dignose/consultation-form";

  export default {
    name: "DiagnoseApply",
    data() {
      return {
        form: {
          status: '1'
        }
      }
    },
    computed: {},
    components: {DiagnoseConsultationForm, DiagnoseDiagnoseForm, DiagnoseBaseForm, Breadcrumb},
    mixins: [diagnoseMixin],
    created() {

    },
    methods: {}
  }
</script>
